import { BaseApiModel } from './BaseApiModel';

export class Classification extends BaseApiModel {
  public code: string;
  public description: string;
  public regionId: string;
  public modifiedAt: Date;
  public createdAt: Date;
}
